import React, { useState } from 'react';
import { Checkbox, FormControlLabel, makeStyles, useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	container: {
		placeItems: 'normal',
		maxWidth: ({ isMobile }) => isMobile && 200,
		width: ({ isMobile, width }) => (isMobile ? 200 : width),
	},
	label: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		minWidth: 120,
		marginRight: 10,
		marginLeft: -13,
		color: ({ touched, hover }) =>
			touched || hover ? theme.palette.primary.main : 'black',
	},
}));

const SimpleCheckbox = ({
	label,
	labelPos = 'top',
	name,
	value,
	onChange,
	disabled = false,
	width,
	containerClass = '',
}) => {
	const isMobile = useMediaQuery('(max-width: 768px)');
	const [touched, setTouched] = useState(false);
	const [hover, setHover] = useState(false);
	const classes = useStyles({ isMobile, touched, hover, width });

	return (
		<FormControlLabel
			disabled={disabled}
			className={classes.container + ` ${containerClass}`}
			label={<p className={classes.label}>{label}</p>}
			labelPlacement={isMobile ? 'top' : labelPos}
			onClick={(event) => event.stopPropagation()}
			onFocus={(event) => event.stopPropagation()}
			control={
				<Checkbox
					onMouseEnter={() => setHover(true)}
					onMouseLeave={() => setHover(false)}
					onBlur={() => setTouched(false)}
					onFocus={(e) => setTouched(true)}
					disabled={disabled}
					onChange={(e) =>
						onChange({ target: { name, value: e.target.checked } })
					}
					checked={value}
					name={name}
					color="primary"
				/>
			}
		/>
	);
};

export default SimpleCheckbox;
